import React, { useEffect, useState } from 'react'
import { FaChevronDown } from 'react-icons/fa'
import { Theme } from '../../lib/theme';
interface MobileShareOutlineModalProps {
  outlines: string[]
  onSelectOutline: (outline: string) => void
  selectedOutline: string
}

export default function ShareOutlineModal({
  outlines,
  onSelectOutline,
  selectedOutline,
}: MobileShareOutlineModalProps) {
  const [isOutlinesOpen, setIsOutlinesOpen] = useState(false)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {}

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
<div>
  {/* Dropdown Button */}
  <div
    id="dropdown-mobile"
    className="w-[98%] ml-1 rounded-lg p-4 cursor-pointer border"
    style={{
      backgroundColor: Theme.colors.background,
      borderColor: Theme.colors.stroke.weak,
    }}
    onClick={() => setIsOutlinesOpen(true)}
  >
    <div className="flex items-center justify-between">
      <span
        className="flex items-center"
        style={{ color: Theme.colors.text.default }}
      >
        <span>{selectedOutline || 'Select Outline'}</span>
      </span>
      <FaChevronDown style={{ color: Theme.colors.text.weak }} />
    </div>
  </div>

  {/* Full-Screen Outlines List */}
  {isOutlinesOpen && (
    <div
      className="fixed inset-0 z-50 p-4"
      style={{ backgroundColor: Theme.colors.background }}
    >
      {/* Header */}
      <div className="flex justify-between items-center mt-5 mb-5">
        <h2
          className="text-lg font-semibold"
          style={{ color: Theme.colors.text.strong }}
        >
          Outlines
        </h2>
        <div className="flex items-center gap-4">
          <button
            onClick={() => setIsOutlinesOpen(false)}
            className="text-sm px-3 py-1 rounded-md hover:underline border"
            style={{
              color: Theme.colors.text.weak,
              borderColor: Theme.colors.button.disabled,
            }}
          >
            Back
          </button>
        </div>
      </div>

      {/* Outlines List */}
      <ul className="space-y-2">
        {outlines.map((outline, index) => (
          <li
            key={index}
            className="py-2 font-medium flex items-center justify-between cursor-pointer"
            style={{ color: Theme.colors.text.default }}
            onClick={() => {
              onSelectOutline(outline);
              setIsOutlinesOpen(false);
            }}
          >
            <span>{index + 1}. {outline}</span>
          </li>
        ))}
      </ul>
    </div>
  )}
</div>

  )
}
